import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import Box from "@mui/material/Box";
import DashboardBox from "features/dashboard/components/DashboardBox";
import LinkStyled from "shared/ui/LinkStyled";
import ScrollBar from "shared/ui/ScrollBar";

const PRICES = [
    {
        id: 1,
        title: "",
        icon: "",
        bgColor: "none",
        price: [
            {name: "< 100 teste/lună"},
            {name: "101-300 teste/lună"},
            {name: "301-500 teste/lună"},
        ],
    },
    {
        id: 2,
        title: "Teste școlare",
        icon: "fas list-check",
        bgColor: "error",
        price: [
            {name: "10 RON/test"},
            {name: "8 RON/test"},
            {name: "6 RON/test"},
        ]
    },
    {
        id: 3,
        title: "Teste BAC/Evaluare Națională",
        icon: "fas file-certificate",
        bgColor: "success",
        price: [
            {name: "15 RON/test"},
            {name: "12 RON/test"},
            {name: "10 RON/test"},
        ]
    },
    {
        id: 3,
        title: "Teste literație limba română/ literație digitală",
        icon: "fas book",
        bgColor: "warning",
        price: [
            {name: "gratuit"},
            {name: "gratuit"},
            {name: "gratuit"},
        ]
    },
]

const PriceTable = () => {

    return (
        <>
            <ScrollBar forceVisible="x" autoHide={false} style={{maxHeight: "100%", maxWidth: "100%", overflowY: "hidden"}} >
            <Grid container spacing={3} direction="row" justifyContent="flex-start" alignItems="stretch" mt="0" mb={3} sx={{minWidth: "990px"}}>
                {PRICES.map((price, index) => (
                    <Grid item xs={3} key={index}>
                        <Box sx={{minWidth: "220px", height: "100%"}}>
                            <DashboardBox
                                type="jsx"
                                number={0}
                                title={price.title}
                                icon={price.icon}
                                bgColor={price.bgColor}
                                sxExtra={{justifyContent: "flex-end"}}
                            >
                                <Box display="flex" flexDirection="column">
                                    {price.price.map((priceItem, index) => (
                                        <Box key={index}>
                                            <Typography variant="body1">{priceItem.name}</Typography>
                                            <Divider sx={{ borderColor: "primary.light", marginBottom: 1, marginTop: 1 }} />
                                        </Box>
                                    ))}
                                </Box>
                            </DashboardBox>
                        </Box>
                    </Grid>
                ))}
            </Grid>
            </ScrollBar>
            <Typography variant="body2" mt={2}>* Prețurile afișate nu includ TVA.</Typography>
            <Typography variant="body2">* Școlile din mediul rural pot beneficia de o reducere între 10% și 30% din
                prețurile afișate, în funcție de anumite condiții. Discount-ul nu se aplică școlilor care au obținut
                finanțare prin programul PNRAS. Aici informații legate de programul PNRAS:
                <LinkStyled to="/pnras"> https://brio.school/pnras</LinkStyled></Typography>
        </>
    )
}

export default PriceTable;